// CrumbTrailCSS.js
import styled from 'styled-components';

export const CrumbtrailContainer = styled.div({
  height: 'auto',
  margin: '7px 0px 0px 0px',
  padding: '3px 0px 2px 0px',
  overflow: 'hidden',
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  borderTop: '1px dashed var(--ds-border-base)',
});

export const CrumbtrailItem = styled.div((props) => ({
  fontSize: '11px',
  fontWeight: 600,
  color: 'var(--ds-text-title)',
  backgroundColor: 'var(--ds-bg-secondary)',
  border: '0px solid #ADBFD966',
  padding: '1px 6px',
  margin: '2px 2px 0 2px',
  borderRadius: '3px',
  height: '22px',
  lineHeight: '20px',
  whiteSpace: 'nowrap', // chip sur 1 ligne
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: `${props.$maxch ?? 18}ch`, // cap par caractères
  flex: '0 1 auto', // autorise le wrap
  cursor: 'pointer',
  '&:hover': {
    fontWeight: 900,
    backgroundColor: 'var(--ds-bg-base)',
  },
}));

export const CrumbtrailSeparator = styled.span({
  display: 'inline-block',
  fontWeight: 600,
  fontSize: '9px',
  color: 'var(--ds-text-title)',
  lineHeight: '22px',
  margin: '2px 2px 0 2px',
  whiteSpace: 'nowrap',
});
